import { Injectable } from '@angular/core';
import { PdfAssemblerService } from './pdf-assembler.service';
import { FileSaverService } from 'ngx-filesaver';
import fontWidths from '../../data/fontWidths.json';
import { PDFDocument } from 'pdf-lib';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  private PDFAssembler: any; // = new PDFAssembler().PDFAssembler;
  private _FileSaverService: any;
  fontWidths: any = fontWidths;
  public blob: any;
  public logoData: any;
  public downloadStatus: number = 0;

  constructor(private FileSaverService: FileSaverService) {
    this._FileSaverService = FileSaverService;
  }

  round = (value, decimals) => {
    return Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals);
  };

  downloadPDF = (pdfPath) => {
    var xhr = new XMLHttpRequest();

    xhr.open('GET', pdfPath, true);
    xhr.responseType = 'blob';

    xhr.onload = () => {
      if (xhr.status == 200) {
        this.downloadStatus = 200;
        this.blob = new Blob([xhr.response], { type: 'application/pdf' });
      }
    };

    xhr.send();
  };

  createPDF = (input, callback) => {
    //Object.assign(this)
    // standard PDF width: 612, height: 792.  Units?  Picas?  Measured Screen equivalent: 375
    let termMapping = {
      '{{activitylevel}}': 'activeLevel',
      '{{age}}': 'ageField',
      '{{calories}}': 'goalCalsField',
      '{{diet}}': 'macroPreference',
      '{{goalwt}}': 'goalWeight',
      '{{dietaryPreference}}': 'dietaryPreference',
      '{{fvd}}': 'totalFists',
      '{{fv}}': 'perMealFists',
      '{{gcd}}': 'totalCarbs',
      '{{gc}}': 'perMealCarbs',
      '{{gfd}}': 'totalFats',
      '{{gf}}': 'perMealFats',
      '{{goal}}': 'goalPreference',
      '{{gpd}}': 'totalProtein',
      '{{gp}}': 'perMealProtein',
      '{{hcd}}': 'totalHandfuls',
      '{{hc}}': 'perMealHandfuls',
      '{{height}}': 'heightField',
      '{{meals}}': 'mealsPerDay',
      '{{longername}}': 'userName',
      '{{name}}': 'userName',
      '{{n}}': 'userName',
      '{{ppd}}': 'totalPalms',
      '{{pp}}': 'perMealPalms',
      '{{sex}}': 'genderBox',
      '{{tf}}': 'perMealThumbs',
      '{{tfd}}': 'totalThumbs',
      '{{weight}}': 'initialWeightField',
      '{{targetd}}': 'targetd',
      '{{cPerc}}': 'finalCarbsPercentage',
      '{{pPerc}}': 'finalProteinPercentage',
      '{{fPerc}}': 'finalFatPercentage',
      '{{protein1}}': 'recommendedFoods.protein[0]',
      '{{protein2}}': 'recommendedFoods.protein[1]',
      '{{protein3}}': 'recommendedFoods.protein[2]',
      '{{protein4}}': 'recommendedFoods.protein[3]',

      '{{veggie1}}': 'recommendedFoods.veggies[0]',
      '{{veggie2}}': 'recommendedFoods.veggies[1]',
      '{{veggie3}}': 'recommendedFoods.veggies[2]',
      '{{veggie4}}': 'recommendedFoods.veggies[3]',

      '{{carbohydrate1}}': 'recommendedFoods.carbs[0]',
      '{{carbohydrate2}}': 'recommendedFoods.carbs[1]',
      '{{carbohydrate3}}': 'recommendedFoods.carbs[2]',
      '{{carbohydrate4}}': 'recommendedFoods.carbs[3]',

      '{{fat1}}': 'recommendedFoods.fat[0]',
      '{{fat2}}': 'recommendedFoods.fat[1]',
      '{{fat3}}': 'recommendedFoods.fat[2]',
      '{{fat4}}': 'recommendedFoods.fat[3]',
      '{{rmr}}': 'initialRMRField',
      '{{bodyfat}}': 'InitialBfpField',
      '{{businessname}}': 'businessName',
      '{{coachname}}': 'coachName',
      empty: '',
    };

    input.userName = input.userName
      ? input.userName.charAt(0).toUpperCase() + input.userName.slice(1)
      : '';
    input.targetd = input.targetDate
      ? input.targetDate.toISOString().split('T')[0]
      : new Date().toISOString().split('T')[0];

    if (input.customDietGrams || input.customDietFists) {
      termMapping['{{calories}}'] = 'customDietCalories';
    }

    var BTregex = /(BT)\n(.*\n){1,7}(ET)/g;
    var wordRegex = /\{\{[a-zA-Z0-9_]+\}\}/g;

    var textPartMap = {
      4: { bt: 0, coords: 1, copy: 2, et: 3 },
      5: { bt: 0, fontOrColor: 1, coords: 2, copy: 3, et: 4 },
      6: { bt: 0, color: 1, font: 2, coords: 3, copy: 4, et: 5 },
      7: { bt: 0, color: 1, gs: 2, font: 3, coords: 4, copy: 5, et: 6 },
      8: { bt: 0, color: 1, gs: 2, font: 3, coords: 4, copy: 5, copy2: 6, et: 7 },
    };

    let coordsMap = {
      7: { fontSize: 0, x: 4, y: 5 },
      9: { fontSize: 2, x: 6, y: 7 },
      11: { fontSize: 4, x: 8, y: 9 },
    };

    var lastFont = '';

    function getTextObj(textString) {
      var obj = {
        parts: textString.split('\n'),
        copy: null,
        copy2: null,
        splitCoords: null,
        coords: null,
        sClength: null,
        fontSize: null,
        x: null,
        y: null,
        font: null,
        color: null,
        gs: null,
        bt: null,
      };

      let partsMap = {
        bt: 'bt',
        gs: 'gs',
        ' k': 'color',
        tf: 'font',
        tm: 'coords',
        tj: 'copy',
        et: 'et',
      };
      obj.parts.forEach((part, i) => {
        let last2 = part.trim().slice(-2).toLowerCase();
        if (partsMap[last2]) {
          obj[partsMap[last2]] = part;
        } else {
          //debugger;
        }
        /*
        } else if (part.trim().slice(-1) == "\\") {
          obj["copy2"] = part;
        }        
        */
      });

      if (obj.copy2) debugger;
      obj.copy = obj.copy2 ? obj.copy2 : obj.copy;

      obj.splitCoords = obj.coords.split(' ');
      obj.sClength = obj.splitCoords.length;
      obj.fontSize = obj.splitCoords[coordsMap[obj.sClength].fontSize];
      obj.x = obj.splitCoords[coordsMap[obj.sClength].x];
      obj.y = obj.splitCoords[coordsMap[obj.sClength].y];

      if (obj.font) {
        obj.font = obj.font.split(' ')[0];
      }

      return obj;
    }

    let getRenderWidth = (inString, font, size) => {
      let width = 0;
      if (this.fontWidths[font] && this.fontWidths[font][size]) {
        for (var i = 0; i < inString.length; i++) {
          if (this.fontWidths[font][size][inString.charAt(i)]) {
            width += this.fontWidths[font][size][inString.charAt(i)].width || 0;
          } else {
            width += 5;
          }
        }
      } else {
        // NVS, todo: more elegant handling when not finding character in fontwidths map
      }

      return width;
    };

    if (this.downloadStatus == 200) {
      let newPdf = new PdfAssemblerService(this.blob);
      newPdf.getPDFStructure().then((pdf) => {
        var pageKids = pdf['/Root']['/Pages']['/Kids'];

        var replacements = {};
        var streamNum = 0;

        // get array of pages to remove for diets that don't match
        let pagesToRemove = Object.keys(input.dietMapping)
          .filter((diet) => {
            return diet != input.dietaryPreference;
          })
          .map((diet) => {
            return input.dietMapping[diet].print[input.calcPath];
          })
          .flat();

        if (input.calcPath == 'pro') {
          pagesToRemove.push(input.dietMapping[input.dietaryPreference].print.macrosSpecifics);
          pagesToRemove = pagesToRemove.flat();
        }

        // TODO: real page removal filtering
        if (input.calcPath == 'self') {
          if (
            ['Athletic Performance', 'Body Recomposition', 'Improve Health'].includes(
              input.goalPreference
            )
          ) {
            pagesToRemove.push(2);
          } else {
            pagesToRemove.push(3);
          }
        } else {
          if (
            ['Athletic Performance', 'Body Recomposition', 'Improve Health'].includes(
              input.goalPreference
            )
          ) {
            pagesToRemove.push(2);
            pagesToRemove.push(5);
          } else {
            pagesToRemove.push(3);
            pagesToRemove.push(4);
          }
          if (input.clientLevelRadio == 'level2or3') {
            pagesToRemove.push(2);
            pagesToRemove.push(3);
          } else {
            pagesToRemove.push(4);
            pagesToRemove.push(5);
          }
        }

        let positionSyncedEntities = {
          percentageBoxes: {
            pPerc: { x: null, width: null, prev: null, strLength: null },
            cPerc: { x: null, width: null, prev: 'pPerc', strLength: null },
            fPerc: { x: null, width: null, prev: 'cPerc', strLength: null },
          },
        };

        var veg_green = '0.3 0.06 0.64 0 k',
          gray = '0 0 0 0.1 k',
          fat_yellowish = '0 0.2 1 0 k',
          carb_orange = '0 0.6 1 0 k',
          prot_blue = '0 0.73 0.89 rg';

        function textPartsReplace(textString) {
          let returnString;

          if (textString.indexOf('{{') > -1) {
            let newCopy, newX;

            let textObj = getTextObj(textString);
            newX = textObj.x;

            if (textObj.font) {
              lastFont = textObj.font;
            }

            // sizing conversion ratio: pdf / browser = 612 / 375
            textObj.copy = textObj.copy.replace(wordRegex, function (inString) {
              if (textObj.copy.indexOf('c_') > -1) {
                // need to center text!
                var inStringLength = getRenderWidth(inString, lastFont, textObj.fontSize);
                returnString = String(eval('input.' + termMapping[inString.replace('c_', '')]));

                if (returnString == 'undefined') returnString = '';
                var returnStringLength = getRenderWidth(returnString, lastFont, textObj.fontSize);

                newX = Math.round(
                  parseFloat(textObj.x) + 0.5 * (inStringLength - returnStringLength)
                );
              } else {
                returnString = String(eval('input.' + termMapping[inString]));
                if (returnString == 'undefined') returnString = '';

                let fullStringMap = {
                  '{{pPerc}}': '% PROTEIN',
                  '{{cPerc}}': '% CARBS',
                  '{{fPerc}}': '% FAT',
                };
                if (['{{pPerc}}', '{{cPerc}}', '{{fPerc}}'].includes(inString)) {
                  //
                  let fullString = returnString + fullStringMap[inString];
                  if (
                    input.customMacroAdjustType != 'own' &&
                    input.macroPreference != 'Very low-carb' &&
                    input.macroPreference !== 'Very low-fat'
                  ) {
                    returnString = '~' + returnString;
                    fullString = '~' + fullString;
                  }
                  var returnStringLength = getRenderWidth(fullString, lastFont, textObj.fontSize);
                  let thisBox = inString.replace('{{', '').replace('}}', '');
                  let pBoxes = positionSyncedEntities.percentageBoxes;
                  ['{{pPerc}}', '{{cPerc}}', '{{fPerc}}'].forEach(function (b) {
                    let thisB = b.replace('{{', '').replace('}}', '');
                    if (!pBoxes[thisB].strLength) {
                      let rS = String(eval('input.' + termMapping[b]));
                      if (rS == 'undefined') returnString = '';

                      let rSL = getRenderWidth(
                        '~' + rS + fullStringMap[b],
                        lastFont,
                        textObj.fontSize
                      );
                      pBoxes[thisB].strLength = rSL;
                    }
                  });

                  newX = pBoxes[thisBox].x + 3;

                  if (
                    pBoxes[thisBox].prev &&
                    newX <= pBoxes[pBoxes[thisBox].prev].x + pBoxes[pBoxes[thisBox].prev].strLength
                  ) {
                    newX =
                      pBoxes[pBoxes[thisBox].prev].x + pBoxes[pBoxes[thisBox].prev].strLength + 15;
                  }

                  let totalWidth = 353.15 + 190.178;

                  if (newX + returnStringLength > totalWidth) {
                    newX -= newX + returnStringLength + 10 - totalWidth;
                  }

                  pBoxes[thisBox].strLength = returnStringLength;
                }
              }

              return returnString;
            });

            // re-assemble fontsize and coords with newX
            //parts[textPartMap[parts.length].coords] = [fontSize, b, c, d, newX, y, tm].join(' ');
            textObj.splitCoords[coordsMap[textObj.sClength].fontSize] = textObj.fontSize;
            textObj.splitCoords[coordsMap[textObj.sClength].x] = newX;
            textObj.splitCoords[coordsMap[textObj.sClength].y] = textObj.y;

            textObj.parts[textPartMap[textObj.parts.length].coords] = textObj.splitCoords.join(' ');

            // Now we'll detect a tilda and, if it's there, we'll split it into two text
            // blocks with the tilda shifted down a couple pixels to center it
            let restOfStringObj = null;
            if (textObj.copy.indexOf('~') > -1) {
              restOfStringObj = JSON.parse(JSON.stringify(textObj));
              textObj.copy = '(~)Tj';
              textObj.splitCoords[coordsMap[textObj.sClength].y] = textObj.y - 2.25;
              textObj.parts[textPartMap[textObj.parts.length].coords] =
                textObj.splitCoords.join(' ');

              restOfStringObj.copy = restOfStringObj.copy.replace('~', '');
              restOfStringObj.splitCoords[coordsMap[restOfStringObj.sClength].x] += getRenderWidth(
                '~',
                lastFont,
                restOfStringObj.fontSize
              );
              restOfStringObj.parts[textPartMap[restOfStringObj.parts.length].copy] =
                restOfStringObj.copy;
              restOfStringObj.parts[textPartMap[restOfStringObj.parts.length].coords] =
                restOfStringObj.splitCoords.join(' ');
            }

            // assign new text
            textObj.parts[textPartMap[textObj.parts.length].copy] = textObj.copy;

            return (
              textObj.parts.join('\n') + (restOfStringObj ? restOfStringObj.parts.join('\n') : '')
            );
          } else {
            return textString;
          }
        }

        function createPercentageBoxes(textPart) {
          let [x1, y1, totalWidth, y2, re] = textPart.split(' ');
          x1 = parseInt(x1);
          totalWidth = parseInt(totalWidth);
          let pPerc = parseInt(input.finalProteinPercentage),
            cPerc = parseInt(input.finalCarbsPercentage),
            fPerc = parseInt(input.finalFatPercentage);
          let pBoxes = positionSyncedEntities.percentageBoxes;
          pBoxes.pPerc.x = x1;
          pBoxes.pPerc.width = (pPerc / 100) * totalWidth;
          pBoxes.cPerc.x = pBoxes.pPerc.width + x1;
          pBoxes.cPerc.width = (cPerc / 100) * totalWidth;
          pBoxes.fPerc.x = pBoxes.cPerc.x + pBoxes.cPerc.width;
          pBoxes.fPerc.width = (fPerc / 100) * totalWidth;
          let pBox =
            'EMC\n' +
            prot_blue +
            '\n' +
            [pBoxes.pPerc.x, y1, pBoxes.pPerc.width, y2, re].join(' ') +
            '\nf';
          let cBox =
            'EMC\n' +
            carb_orange +
            '\n' +
            [pBoxes.cPerc.x, y1, pBoxes.cPerc.width, y2, re].join(' ') +
            '\nf';
          let fBox =
            'EMC\n' +
            fat_yellowish +
            '\n' +
            [pBoxes.fPerc.x, y1, pBoxes.fPerc.width, y2, re].join(' ') +
            '\nf';
          return [pBox, cBox, fBox].join('\n');
        }

        let createActivityBox = (textPart) => {
          let [x1, y1, width, height, re] = textPart.split(' ');
          let newWidth = width * (1 - (2.3 - input.initialPALField));
          return [x1, y1, newWidth, height, re].join(' ');
        };

        let dailyBoxes = {
          0: {
            do: createDailyBoxes,
          },
        };
        /* change box length */
        let needsPage = {
          1: {
            coords: '188.75 251.02 353.15 20.68 re',
            do: createPercentageBoxes,
          },
          3: {
            coords: '188.7 415.995 353.2 17.99 re',
            do: createActivityBox,
          },
        };

        let pathPageTasks = {
          self: {
            2: needsPage,
            3: needsPage,
          },
          pro: {
            2: needsPage,
            3: needsPage,
            4: needsPage,
            5: needsPage,
          },
          selfWithProCopy: {
            2: needsPage,
            3: needsPage,
            4: needsPage,
            5: needsPage,
          },
        };

        let dailyBoxesMap = {
          self: 14,
          pro: 16,
          selfWithProCopy: 16,
        };

        //           let imageEmbed, imageResource;
        //           if (this.logoData) {
        //             imageResource = {
        //               "/BitsPerComponent": 8,
        //               "/ColorSpace": "/DeviceRGB",
        //               "/Filter": "/DCTDecode",
        //               "/Height": this.logoData.height,
        //               "/Width": this.logoData.width,
        //               "/Length": this.logoData.data.length,
        //               "/Subtype": "/Image",
        //               "/Type": "/XObject",
        //               gen: 0,
        //               num: 4,
        //               stream: this.logoData.data
        //             }

        //             //let newHeight = Math.round((120 / this.logoData.width) * this.logoData.height);
        //             imageEmbed = `q
        // 1 0 0 1 62 22 cm
        // 1 0 0 1 0 0 cm
        // ${this.logoData.width / 4} 0 0 ${this.logoData.height / 4} 0 0 cm
        // 1 0 0 1 0 0 cm
        // /Image-logo Do
        // Q`;
        //           }
        // do all text variable replacements, remove pages, draw boxes
        pageKids.forEach((thisPage, page) => {
          if (pagesToRemove.includes(page)) {
            delete pdf['/Root']['/Pages']['/Kids'][page];
          } else {
            var contents = [];
            contents = contents.concat(thisPage['/Contents']);

            // if (this.logoData) {
            //   thisPage['/Resources']['/XObject'] = thisPage['/Resources']['/XObject'] ? thisPage['/Resources']['/XObject'] : {};
            //   thisPage['/Resources']['/XObject']['/Image-logo'] = imageResource;
            // }

            if (contents.length > 0) {
              contents.forEach((thisContents, streamNum) => {
                //console.log(`page ${page}: ${thisContents.stream}`);

                thisContents.stream = alterBoxes(thisContents.stream, page);
                thisContents.stream = thisContents.stream.replace(BTregex, textPartsReplace);

                if (dailyBoxesMap[input.calcPath] == page) {
                  thisContents.stream = createDailyBoxes(thisContents.stream, page);
                }

                //thisContents.stream += imageEmbed;

                if (thisPage['/Contents'][streamNum]) {
                  thisPage['/Contents'][streamNum].stream = thisContents.stream;
                } else {
                  thisPage['/Contents'].stream = thisContents.stream;
                }
              });
            }

            // contents[contents.length - 1].stream += imageEmbed;
          }
        });

        function alterBoxes(stream, page) {
          let thisPagesTasks = pathPageTasks[input.calcPath][page]
            ? pathPageTasks[input.calcPath][page]
            : null;
          if (thisPagesTasks) {
            let streamIndex = 0;
            let newStream = stream.replace(/↵/g, '\n').replace(/^.* re/gm, function (textPart) {
              let newText = textPart;
              if (thisPagesTasks[streamIndex]) {
                newText = thisPagesTasks[streamIndex].do(textPart);
              }
              streamIndex++;
              return newText;
            });
            return newStream;
          } else {
            return stream;
          }
        }

        function createDailyBoxes(stream, page) {
          stream = stream.replace(/\\037/g, '');

          var absLeft = 166.7843 /* */,
            absTopCentered = 440.625, // this is one column, vertically centered
            nextCol = 100.2, // 266.9843 = 166.7843
            innerRowHeight = 13, // 448.125 - 433.125
            betweenRowHeight = 56.0, //440.625 - 384.625
            spaceWidth = 2.4, //395.997 - 394.3969
            boxWidth = 10.4; //401.2 - 394.3969 - 1.6000999999999976
          var veg_green = '0.3 0.06 0.64 0 k',
            fat_yellowish = '0 0.2 1 0 k',
            carb_orange = '0 0.6 1 0 k',
            prot_blue = '0.75 0 0.07 0 k',
            veg_green = '0.4 0 0.85 0 k';

          var checkChart = {
            protein: { left: absLeft, color: prot_blue, field: 'totalPalms' },
            veggies: { left: absLeft + nextCol, color: veg_green, field: 'totalFists' },
            carbs: { left: absLeft + 2 * nextCol, color: carb_orange, field: 'totalHandfuls' },
            fats: { left: absLeft + 3 * nextCol, color: fat_yellowish, field: 'totalThumbs' },
          };

          function boxGroup(boxX, boxY, activeNum, color) {
            activeNum = activeNum > 24 ? 24 : activeNum;
            var outputString = '';
            let numRows = Math.ceil(activeNum / 6);
            boxY += 0.5 * (innerRowHeight * (numRows - 1));
            for (let row = 0; row < numRows; row++) {
              let thisRowY = boxY - row * innerRowHeight;
              let thisCircleCount = Math.floor(activeNum / 6) - 1 >= row ? 6 : activeNum % 6;
              let thisRowX =
                boxX +
                37.5 -
                0.5 * (thisCircleCount * boxWidth + (thisCircleCount - 1) * spaceWidth);

              let theseCircles = Array.apply(null, Array(thisCircleCount)).map((x) => '\\037'); // font awesome circle
              outputString += `BT
${color}
10 0 0 10 ${thisRowX} ${thisRowY} Tm
(${theseCircles.join(' ')})Tj
ET
EMC
`;
            }
            return outputString;
          }

          function getTotalBoxPortions(portion) {
            portion = String(portion);
            if (portion.indexOf(' or ') > -1) {
              portion = portion.split(' or ')[1];
            }
            return parseInt(portion);
          }

          function mealPartGroup(mealPart) {
            var outputString = '';
            for (let day = 0; day < 7; day++) {
              outputString += boxGroup(
                mealPart.left,
                absTopCentered - day * betweenRowHeight,
                getTotalBoxPortions(input[mealPart.field]),
                mealPart.color
              );
            }
            return outputString;
          }

          Object.keys(checkChart).forEach(function (thisPart) {
            stream += mealPartGroup(checkChart[thisPart]);
          });

          return stream;
        }

        newPdf.removeRootEntries();

        newPdf.assemblePdf('ArrayBuffer').then((pdfFile) => {
          PDFDocument.load(<ArrayBuffer>pdfFile).then((pdfDoc) => {
            if (this.logoData) {
              pdfDoc.embedJpg(this.logoData.data).then((jpgImage) => {
                const pages = pdfDoc.getPages();
                const jpgDims = jpgImage.scale(0.25);

                pages.forEach((page) => {
                  page.drawImage(jpgImage, {
                    x: page.getWidth() / 10,
                    y: 25,
                    width: jpgDims.width,
                    height: jpgDims.height,
                  });
                });

                pdfDoc.saveAsBase64({ dataUri: true }).then((pdfBytes) => {
                  // this._FileSaverService.save(pdfBytes, 'PrecisionNutrition-MacroPortionCalculations.pdf');
                  callback(pdfBytes);
                });
              });
            } else {
              pdfDoc.saveAsBase64({ dataUri: true }).then((pdfBytes) => {
                // this._FileSaverService.save(pdfBytes, 'PrecisionNutrition-MacroPortionCalculations.pdf');
                callback(pdfBytes);
              });
            }
          });

          //this._FileSaverService.headers = {'Content-Disposition':'attachment', 'filename':'PrecisionNutrition-MacroPortionCalculations.pdf'};
        });
      });
    }
  };
}
